import React, { useEffect, useMemo, useState } from 'react'
import { Form, InputGroup, Modal } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm'
import {
  useAddDispatcherMutation,
  useEditDispatcherMutation,
} from '../../redux/services/DispatcherService'
import { sweetAlert } from '../../utils'
import { responseError } from '../../helpers/responseHandler'

const AddAdmins = ({ type, show, handleClose, isEdit }) => {
  const [isPassword, setIsPassword] = useState(true)
  const [isCPassword, setIsCPassword] = useState(true)

  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()

  const [addRequest, { isLoading: addLoading }] = useAddDispatcherMutation()
  const [editRequest, { isLoading: editLoading }] = useEditDispatcherMutation()

  const onSubmit = async data => {
    console.log(data)
    if (isEdit) {
      const newForm = { ...data }
      await editRequest({ id: isEdit?.id, newForm })
        .unwrap()
        .then(res => {
          if (res?.status) {
            sweetAlert(res?.message, 'success')
            // navigate(-1)
            handleClose()
          }
        })
        .catch(err => {
          responseError(err)
        })
    } else {
      const newForm = { ...data, account_type: type }
      await addRequest(newForm)
        .unwrap()
        .then(res => {
          if (res?.status) {
            sweetAlert(res?.message, 'success')
            // navigate(-1)
            handleClose()
          }
        })
        .catch(err => {
          responseError(err)
        })
    }
  }

  return (
    <>
      <Modal show={show} size='lg' onHide={handleClose} backdrop='static' keyboard={false}>
        <Modal.Header className='border-0' closeButton>
          <Modal.Title className='h5'>Create Admin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} id='company-status'>
            <div className='row'>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>First Name:</Form.Label>
                  <Controller
                    name='first_name'
                    control={control}
                    defaultValue={isEdit?.first_name || ''}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type='text' isInvalid={errors.first_name} />
                    )}
                  />
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>Last Name:</Form.Label>
                  <Controller
                    name='last_name'
                    control={control}
                    defaultValue={isEdit?.last_name || ''}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control {...field} type='text' isInvalid={errors.last_name} />
                    )}
                  />
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>Email:</Form.Label>
                  <Controller
                    name='email'
                    control={control}
                    defaultValue={isEdit?.email || ''}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type='email'
                        isInvalid={errors.email}
                        disabled={isEdit?.email ? true : false}
                      />
                    )}
                  />
                </Form.Group>
              </div>
              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>Phone:</Form.Label>
                  <Controller
                    name='phone'
                    control={control}
                    defaultValue={isEdit?.phone || '+1'}
                    rules={{
                      required: true,
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        country={'us'} // Default country
                        inputProps={{
                          name: 'phone',
                          required: true,
                          autoFocus: true,
                        }}
                      />
                    )}
                  />
                </Form.Group>
              </div>

              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>Password:</Form.Label>
                  <Controller
                    name='password'
                    control={control}
                    defaultValue={isEdit?.password || ''}
                    rules={{
                      required: isEdit ? false : true,
                    }}
                    render={({ field }) => (
                      <>
                        <InputGroup className='mb-3'>
                          <Form.Control
                            {...field}
                            type={isPassword ? 'password' : 'text'}
                            isInvalid={errors.password}
                            aria-describedby='basic-addon2'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            type='button'
                            onClick={() => setIsPassword(prev => !prev)}
                          >
                            {isPassword ? <i class='fa fa-eye' /> : <i class='fa fa-eye-slash' />}
                          </InputGroup.Text>
                        </InputGroup>
                      </>
                    )}
                  />
                </Form.Group>
              </div>

              <div className='col-md-6'>
                <Form.Group className='mb-3'>
                  <Form.Label>Confirm Password:</Form.Label>
                  <Controller
                    name='password_confirmation'
                    control={control}
                    defaultValue={isEdit?.password_confirmation || ''}
                    rules={{
                      required: isEdit ? false : true,
                    }}
                    render={({ field }) => (
                      <>
                        <InputGroup className='mb-3'>
                          <Form.Control
                            {...field}
                            type={isCPassword ? 'password' : 'text'}
                            isInvalid={errors.password_confirmation}
                            aria-describedby='basic-addon2'
                          />
                          <InputGroup.Text
                            id='basic-addon2'
                            type='button'
                            onClick={() => setIsCPassword(prev => !prev)}
                          >
                            {isCPassword ? <i class='fa fa-eye' /> : <i class='fa fa-eye-slash' />}
                          </InputGroup.Text>
                        </InputGroup>
                      </>
                    )}
                  />
                </Form.Group>
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className='border-0'>
          <LoadingButtonWithForm
            isLoading={editLoading ? editLoading : addLoading}
            name='Save'
            form='company-status'
          />
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddAdmins
